var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('multiselect',{class:_vm.size,attrs:{"value":_vm.selectedValue,"track-by":"value","label":"text","deselect-label":_vm.deselectLabel,"placeholder":_vm.placeholder,"allow-empty":_vm.allowEmpty,"show-labels":_vm.showLabels,"options":_vm.internalOptions},on:{"input":_vm.changeQuery}})
}
var staticRenderFns = []

export { render, staticRenderFns }